module.exports = __webpack_public_path__ + "img/10.2b1c6190.png";